module.exports = __webpack_public_path__ + "img/cross.e42684bc.svg";